module.exports = __webpack_public_path__ + "img/icon-money-star.65760068.png";